const colors = {
  alpha: 'orange',
  beta: 'teal'
};

const getStatusColor = status => colors[status];

export default { getStatusColor };
